import { useState, useEffect, useContext } from "react";
import "./FoundingBanner.css";
import api from "../../api/api";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

function FoundingBanner() {
  const { user } = useContext(AuthContext);
  const [usedCount, setUsedCount] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsedCount = async () => {
      try {
        // Use the same endpoint as Upgrade.jsx for consistency
        const res = await api.get("/billing/promo/LAUNCH50/remaining");
        setUsedCount(res.data.used ?? 0);
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch promo stats", err);
        setLoading(false);
      }
    };
    fetchUsedCount();
  }, []);

  const isPro = user?.subscription?.plan === "PRO" && user?.subscription?.status === "ACTIVE";
  
  // Never hide even if count is high; creating a permanent "Limited Deal" feel
  if (loading || isPro) return null;

  // Smart Urgency: same logic as Upgrade.jsx
  const displayRemaining = usedCount !== null 
    ? (usedCount < 45 ? (50 - usedCount) : Math.max(3, 8 - (usedCount % 6)))
    : null;

  return (
    <div className="founding-banner" onClick={() => navigate("/upgrade")}>
      <div className="banner-content">
        <span className="badge">DEAL</span>
        <p>
          <strong>LIMITED DEAL:</strong> Get Learnlia PRO for just <span className="highlight">₹49</span>. 
          <span className="urgency"> Only {displayRemaining ?? "..."} spots left at this price!</span>
        </p>
      </div>
      <button className="claim-btn">Get Started →</button>
    </div>
  );
}

export default FoundingBanner;
